import React, { useEffect } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CDashboard } from 'components/Visualization';
import {
  blueprintDashboardConfig,
  blueprintDashboardSummaryConfig,
} from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/config';
import { actions } from 'containers/PolicyHub/Blueprints/slice';

export const BlueprintDashboard = () => {
  const params = useParams<{ id: string }>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.getViolationsByAccount({ q: { blueprintId: params?.id! } }),
    );
    dispatch(
      actions.getViolationsByEnvironment({
        q: { blueprintId: params?.id!, byEnvironment: true },
      }),
    );
  }, [params?.id, dispatch]);

  return (
    <Stack spacing={4} pt={2}>
      <CDashboard dashboardWidgets={blueprintDashboardConfig} />
      <Stack>
        <Box fontSize="md" fontWeight={600}>
          SUMMARY
        </Box>
        <CDashboard dashboardWidgets={blueprintDashboardSummaryConfig} />
      </Stack>
    </Stack>
  );
};
